module.exports = __webpack_public_path__ + "static/LogoCS-017efdc001ab52da0ad786072fa8a9bd.svg";